module.exports = __webpack_public_path__ + "static/media/b1.22f52c93.png";